import monitor from "./monitor"

export default {
  namespaced: true,
  state: {
    componentData: [], // 画布内组件数据
    canvasStyleData: { // vis画布页面全局数据
      width: 1200,
      height: 740,
      scale: 100,
      img: null
    },
    isClickComponent: false,
    isLeftAtterControlShow: false,
    isBottomAtterAllControlShow: false,
    leftMenuName: null,
    equipmentData: {},
    isMapListShow: true,
    isCompTooltipsShow: false, // disabled:true为隐藏，false为显示
    isLoactionEquipmentListLoading: false,
    isCanvasLoading: false,
    canvasLoadingTxt: null,
    // isSurComponentMove: false, // visual选中元素是否被拖动
    isLeftAreaShow: false, // 侧边
    flootNumber: 0, // 楼层数
    isSceneAddShow: false, // 添加场景界面显示
    visualIndexTab: null, // 1、equ 设备tab  2、scene 场景tab 3、ifttt 自动化tab
    isSceneAddDevice: false,
    SceneNo: null,
    editBgLog: false,
    isTreeMenuShow: true, // visual区域选择折叠
    currentTool: null, // 判断工具类状态
    opacity: 1,
    checkedAreaIds: [], // 选择房间
    spaceDown: false, // 按下空格键-用来移动画布 true按下 false松开
    isCtrlDown: false, // 判断ctrl键-多选  true按下 false松开
    areaHighId: -1, // 选择区id
    areaName: '', // 选择区域名
    canvasOpacity: 1, // 背景透明度
    visibleTitle: false, // 编辑-显示设备标签
    visibleRectTxt:true,
    visibleBgImage:true,
    canvasWidth: null,
    canvasHeight: null,
    imageIndex: 1, // 当前第几张底图
    imageNumber: 0,
    isTriggerSideTabShow: false, // 是否触发侧边栏显示, 地图监控-默认折叠左右的tab, 选中区域后, 触发一次展开 ... (史工的逻辑)
    allRooms:{
      Rooms:[],
      Images:[],
    },//区域内所有房间,image信息
    treeLevel:-1,
    monitorTab:'', //监控页面tab
    zoomOffset:{x:0,y:0}
  },
  mutations: {
    setTreeLevel(state, level) {
      state.treeLevel = level
    },
    setTreeMenuShow(state) {
      state.isTreeMenuShow = !state.isTreeMenuShow
    },
    setClickComponentStatus (state, status) {
      state.isClickComponent = status
    },

    setEditMode (state, mode) {
      state.editMode = mode
    },

    setCanvasStyle (state, style) {
      state.canvasStyleData = style
    },

    setCurComponent (state, {
      component,
      index
    }) {
      state.curComponent = component
      state.curComponentIndex = index
    },

    setCurComponentAll (state, components) {
      state.curComponentAll = components
    },

    setShapeStyle ({
      curComponent
    }, {
      top,
      left,
      width,
      height,
      rotate
    }) {
      if (top) curComponent.style.top = top
      if (left) curComponent.style.left = left
      if (width) curComponent.style.width = width
      if (height) curComponent.style.height = height
      if (rotate) curComponent.style.rotate = rotate
    },

    setShapeSingleStyle ({
      curComponent
    }, {
      key,
      value
    }) {
      curComponent.style[key] = value
    },

    setComponentData (state, componentData = []) {
      Vue.set(state, 'componentData', componentData)
    },

    addComponent (state, {
      component,
      index
    }) {
      const needToChange = ['width', 'height', 'fontSize']
      Object.keys(component.style).forEach((key) => {
        if (needToChange.includes(key)) {
          // 根据原来的比例获取样式原来的尺寸
          // 再用原来的尺寸 * 现在的比例得出新的尺寸
          // 保留3位有效秒避免偏移
          component.style[key] = Number(
            ((component.style[key] * parseInt(state.canvasStyleData.scale)) / 100).toFixed(
              3
            )
          )
        }
      })

      if (index !== undefined) {
        state.componentData.splice(index, 0, component)
      } else {
        state.componentData.push(component)
      }
    },

    deleteComponent (state, index) {
      if (index === undefined) {
        index = state.curComponentIndex
      }

      if (index == state.curComponentIndex) {
        state.curComponentIndex = null
        state.curComponent = null
      }
      state.componentData.splice(index, 1)
    },
    resetVisual (state) {
      state.canvasStyleData = {
        width: 1200,
        height: 740,
        scale: 100,
        img: null
      }
      state.componentData = []
    },

    // button 0左击 2右击
    // showLeftAtterControlList (state, {
    //   component,
    //   button
    // }) {
    //   if (state.curComponent && state.curComponent.component === 'rect-shape') {
    //     const isClickComponent = (state.curComponent.component === 'Equipment' || state.curComponent.component === 'Group') && button === 0
    //     const isRightClickComponent = (state.curComponent.component === 'rect-shape' && button === 2)
    //     if (isClickComponent || isRightClickComponent) {
    //       state.isLeftAtterControlShow = true
    //       state.leftMenuName = component
    //     } else {
    //       state.isLeftAtterControlShow = false
    //       state.leftMenuName = null
    //     }
    //   } else {
    //     state.isLeftAtterControlShow = false
    //     state.leftMenuName = null
    //   }
    // },
    setCheckedAreaIds (state, data) {
      state.checkedAreaIds = data
    },
    hideLeftAtterControlList (state) {
      state.isLeftAtterControlShow = false
    },
    setIntoMapEquipmentData (state, data) {
      console.log("🚀 ~ setIntoMapEquipmentData ~ data:", data)
      state.equipmentData = data
    },
    showBottomAtterAllControlList (state) {
      state.isBottomAtterAllControlShow = true
    },
    hideBottomAtterAllControlList (state) {
      state.isBottomAtterAllControlShow = false
    },
    showMapList (state) {
      state.isMapListShow = true
    },
    hideMapList (state) {
      state.isMapListShow = false
    },
    showCompTooltips (state) {
      state.isCompTooltipsShow = false
      state.isCompTxtShow = false
    },
    hideCompTooltips (state) {
      state.isCompTooltipsShow = true
      state.isCompTxtShow = true
    },
    showLeftArea (state) {
      state.isLeftAreaShow = true
    },
    hideLeftArea (state) {
      state.isLeftAreaShow = false
    },
    setLoactionEquipmentListData (state, payload) {
      state.loactionEquipmentListData = payload
    },
    setLoactionEquipmentListLoading (state, payload) {
      state.isLoactionEquipmentListLoading = payload
    },
    setCanvasLoading (state, {
      value,
      text
    }) {
      state.canvasLoadingTxt = text
      state.isCanvasLoading = value
    },
    setVisualIndexTab (state, type) {
      state.visualIndexTab = type
    },
    setIsCanInMap (state, payload) { },
    initComponentData (state, payload) {
      // 给老画布初始化设备数据
      state.componentData.forEach((item, index) => {
        item.isSelected = false
        item.isChecked = false
        item.isActive = false
        item.isDisabled = false
        item.isHidden = false
      })
    },
    setEquMouseHandle (state, {
      msg,
      type
    }) {
      state.componentData.forEach((item, index) => {
        if (item.component === 'Equipment') {
          if ((msg.isVirtual === '1' && item.propValue.unionId === msg.unionId) || (msg.isVirtual === '0' && item.id === msg.id)) {
            item.isActive = type
          }
        }
      })
    },
    setEquSelected (state, {
      msg,
      type
    }) {
      state.componentData.forEach((item, index) => {
        if (item.component === 'Equipment') {
          if (item.propValue.unionId === msg.unionId) {
            item.isSelected = type
          }
        }
      })
    },
    setSceneNo (state, data) {
      state.sceneNo = data
      state.isSceneAddShow = true
    },
    setAreaHidden (state) {
      state.componentData.forEach(item => {
        if (item.component === 'rect-shape') {
          if (item.areaId !== state.areaHighId) {
            item.isHidden = true
          }
        } else if (item.component === 'Equipment') {
          if (item.propValue.Gpno !== state.areaHighId) {
            item.isHidden = true
          }
        }
      })
    },
    // setEquHiddenDevice (state, {
    //   unionId,
    //   type
    // }) {
    //   state.componentData.forEach(item => {
    //     if (item.component === 'Equipment') {
    //       if (item.propValue.unionId !== unionId && item.propValue.Gpno === state.areaHighId) {
    //         Vue.set(item, 'isHidden', type)
    //       } else {
    //         Vue.set(item, 'isHidden', !type)
    //       }
    //     }
    //   })
    // },
    setEquHiddenMsg (state, {
      unionId,
      type
    }) {
      state.componentData.forEach(comItem => {
        if (comItem.component === 'Equipment') {
          if (comItem.propValue.unionId !== unionId) {
            comItem.isHidden = true
            comItem.isSelected = true
          } else {
            comItem.isHidden = false
          }
        }
      })
    },
    setCurrentTool (state, tool) {
      state.currentTool = tool
    },
    setAreaHightInfo (state, info) {
      state.areaHighId = Number(info.id)
      if(info?.name){
        state.areaName = info.name || ''
      }
    },
    setCanvasOpacity (state, opacity) {
      state.canvasOpacity = opacity * 0.01
    },
    setVisibleTitle (state, boolean) {
      state.visibleTitle = boolean
    },
    setCanvasInfo (state, info) {
      state.canvasWidth = info.width
      state.canvasHeight = info.height
    },
    setImageIndex (state, index) {
      state.imageIndex = index
    },
    setIsTriggerSideTabShow(state, bool) {
      state.isTriggerSideTabShow = bool
    },
    setAllRooms(state, rooms) {
      state.allRooms = rooms
    },
    setMonitorTab(state,tab){
      state.monitorTab = tab.tab
    },
    
    updateZoomOffset(state,offset){
      state.zoomOffset = offset
    }

  },
  actions: {
    fetchLoactionEquipmentListData (store, data) {
      store.commit('setLoactionEquipmentListData', data)
    },
    fetchLoactionEquipmentListLoading (store, data) {
      store.commit('setLoactionEquipmentListLoading', data)
    }
  }

}
